/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const CHUNK_TYPES = [
  'polyword',
  'collocation',
  'sentence_frame',
  'institutionalized_utterance',
  'phrasal_verb',
  'greeting',
  'filler',
  'discourse_marker',
  'social_formula',
  'fixed_expression',
  'semi_fixed',
] as const;

export const chunkTypeSchema = z.enum(CHUNK_TYPES);

export type IChunkType = z.infer<typeof chunkTypeSchema>;
